import React from "react";
import { motion } from "motion/react";

import * as styles from "@/features/betslip/components/overlays/SlideOut.module.scss";

type SlideOutProps = {
  children?: React.ReactNode;
  onClose?: () => void;
};

export const SlideOut = ({ children, onClose }: SlideOutProps) => (
  <>
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className={styles.scrim}
      onClick={onClose}
    />
    <motion.div
      initial={{ y: "100%" }}
      animate={{ y: 0 }}
      exit={{ y: "100%" }}
      transition={{ duration: 0.25, ease: [0.32, 0.72, 0, 1] }}
      className={styles.container}
    >
      {children}
    </motion.div>
  </>
);
